<div class="widget-header flex flex-row place-content-between items-start mb-5">
  <h1 class="text-2xl font-medium">Working hours</h1>
  <span class="actions flex flex-col items-end">
    <button mat-icon-button *ngIf="!editMode; else saveAction" (click)="editMode = !editMode" class="mr-[-12px] mt-[-12px]">
      <mat-icon class="material-icons-outlined">edit</mat-icon>
    </button>
    <ng-template #saveAction>
      <div>
        <button mat-icon-button class="save-button" (click)="saveAvailability(); closeAllDayAvailabilitySelector()" [disabled]="availabilitiesForm.invalid" class="mt-[-12px]">
          <mat-icon class="material-icons-outlined">save</mat-icon>
        </button>
        <button mat-icon-button (click)="editMode = !editMode; patchValues(); closeAllDayAvailabilitySelector()" class="mr-[-12px] mt-[-12px]">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </ng-template>
    <span class="font-medium">Hours per day:</span>
  </span>
</div>
<div class="widget-content">
  <div [formGroup]="availabilitiesForm" class="availability">
    <div class="availabilityData">
      <ng-container *ngFor="let day of weekDays">
        <thehubz-day-availability-selector
          [formControlName]="day.key"
          [day]="day.label"
          [editMode]="editMode"
          (applyToAll)="applyTimeSlotsSelectedDays($event)"
          class="mb-2"
        ></thehubz-day-availability-selector>
      </ng-container>
    </div>
    <div class="flex flex-row justify-end items-baseline font-medium">
      <h3 class="mb-1 mr-3">Hours per week:</h3>
      <h2 class="mt-1 text-2xl">{{ availabilitiesForm.getRawValue() | getTimeSlots | totalDuration }}</h2>
    </div>
  </div>
</div>
